import { useClearSessionStateCache } from "@lending/hooks/queries/useGetSessionQuery";
import { $baseApi } from "@lending/lib/api";

function useCreateCreditCardApplicationQuery() {
  // A successful create mints the lending session cookie, so the cached
  // session-state probe (which gates the account menu) must be refreshed.
  const clearSessionStateCache = useClearSessionStateCache();

  return $baseApi.useMutation("post", "/v2/lending/credit_card_applications/", {
    onSuccess: () => clearSessionStateCache(),
  });
}

export { useCreateCreditCardApplicationQuery };
